import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="uxpmenuitem" id="uxpmenuitem"></a>
    <h1 {...{
      "id": "uxpmenuitem"
    }}>{`UxpMenuItem`}</h1>
    <a name="new-uxpmenuitem-new" id="new-uxpmenuitem-new"></a>
    <h2 {...{
      "id": "uxpmenuitem-1"
    }}>{`UxpMenuItem()`}</h2>
    <p>{`Class describing a single menu item of a panel`}</p>
    <a name="uxpmenuitem-id" id="uxpmenuitem-id"></a>
    <h2 {...{
      "id": "id--string"
    }}>{`id : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Get menu item id`}</p>
    <a name="uxpmenuitem-label" id="uxpmenuitem-label"></a>
    <h2 {...{
      "id": "label--string"
    }}>{`label ⇒ `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p>{`Get menu item label, localized string`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{`  `}</p>
    <a name="uxpmenuitem-enabled" id="uxpmenuitem-enabled"></a>
    <h2 {...{
      "id": "enabled--boolean"
    }}>{`enabled ⇒ `}<inlineCode parentName="h2">{`boolean`}</inlineCode></h2>
    <p>{`Get menu item enable state`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`boolean`}</inlineCode>{`  `}</p>
    <a name="uxpmenuitem-checked" id="uxpmenuitem-checked"></a>
    <h2 {...{
      "id": "checked--boolean"
    }}>{`checked ⇒ `}<inlineCode parentName="h2">{`boolean`}</inlineCode></h2>
    <p>{`Get menu item checked state`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`boolean`}</inlineCode>{`  `}</p>
    <a name="uxpmenuitem-submenu" id="uxpmenuitem-submenu"></a>
    <h2 {...{
      "id": "submenu--uxpmenuitems"
    }}>{`submenu ⇒ `}<inlineCode parentName="h2">{`UxpMenuItems`}</inlineCode></h2>
    <p>{`Get menu submenu`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`UxpMenuItems`}</inlineCode>{`  `}</p>
    <a name="uxpmenuitem-parent" id="uxpmenuitem-parent"></a>
    <h2 {...{
      "id": "parent--uxpmenuitems"
    }}>{`parent ⇒ `}<inlineCode parentName="h2">{`UxpMenuItems`}</inlineCode></h2>
    <p>{`Get menu parent.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`UxpMenuItems`}</inlineCode>{`  `}</p>
    <a name="uxpmenuitem-label" id="uxpmenuitem-label"></a>
    <h2 {...{
      "id": "label"
    }}>{`label`}</h2>
    <p>{`Set label of the menu item. The label will be updated immediately, asynchronously.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`label`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`should be a localized string`}</td>
        </tr>
      </tbody>
    </table>
    <a name="uxpmenuitem-enabled" id="uxpmenuitem-enabled"></a>
    <h2 {...{
      "id": "enabled"
    }}>{`enabled`}</h2>
    <p>{`Set enabled state of the menu item. The state will be updated immediately, asynchronously.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`enabled`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="uxpmenuitem-checked" id="uxpmenuitem-checked"></a>
    <h2 {...{
      "id": "checked"
    }}>{`checked`}</h2>
    <p>{`Set checked state of the menu item. The state will be updated immediately, asynchronously.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`checked`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="uxpmenuitem-remove" id="uxpmenuitem-remove"></a>
    <h2 {...{
      "id": "remove"
    }}>{`remove()`}</h2>
    <p>{`Remove the menu item`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      